
import Component from 'vue-class-component';
import Init from '@/Init';

@Component({})
export default class AppInitScreen extends Init {}
